export default __webpack_public_path__ + "static/media/Hood of the Whispering Blade.e2f01d20.jpg";